module.exports = __webpack_public_path__ + "img/Home_Tablet_03.4b83a06b.jpg";